import { render, staticRenderFns } from "./BusGisPrizeModal.vue?vue&type=template&id=111fea28&"
import script from "./BusGisPrizeModal.vue?vue&type=script&lang=js&"
export * from "./BusGisPrizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports